module.exports = __webpack_public_path__ + "static/media/keema_jaymes-IG-2.f418dcca.PNG";